import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { formatResetDate } from '../utils/quota';
import { ZapIcon } from './icons';

interface QuotaLowHintProps {
  remaining: number;
  resetsAt: string;
  fallbackModel: string;
  onSwitch: () => void;
}

const QuotaLowHint: React.FC<QuotaLowHintProps> = ({ remaining, resetsAt, fallbackModel, onSwitch }) => {
  const { colors, theme } = useTheme();
  const summary = remaining === 0
    ? 'No advanced requests left this month'
    : `${remaining} advanced request${remaining === 1 ? '' : 's'} left this month`;

  return (
    <div data-testid="quota-low-hint" style={{
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '6px',
      margin: '0 8px 8px',
      fontSize: '12px',
      color: theme === 'dark' ? '#fbbf24' : '#b45309',
    }}>
      <ZapIcon size={13} />
      <span>{summary} · resets {formatResetDate(resetsAt)} ·</span>
      <button
        type="button"
        onClick={onSwitch}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          fontSize: '12px',
          color: colors.primary,
        }}
      >
        Use {fallbackModel} instead
      </button>
    </div>
  );
};

export default QuotaLowHint;
